/**
 *  Microtaskers
 *  Nom: ANDRIARILALAO Johny Lino
 *  Email: johny.andriarilalao@gmail.com
 */

import ReactDOM from 'react-dom/client'
import React from 'react'
import App from './App'
import reportWebVitals from './reportWebVitals'

// ===== IGNORER L'ERREUR RÉSIZEOBSERVER BÉNIGNE =====
// Cette erreur est causée par InfiniteScroll et n'affecte pas le fonctionnement
const resizeObserverLoopErr = /^ResizeObserver loop completed with undelivered notifications/;
const originalError = window.console.error;
window.console.error = (...args) => {
  if (args[0] && resizeObserverLoopErr.test(args[0])) {
    return; // Ignorer cette erreur bénigne
  }
  originalError.call(window.console, ...args);
};

// ===== SIMULATEUR iOS (Développement uniquement) =====
// DÉSACTIVÉ - Pour réactiver, décommenter le code ci-dessous
/*
if (process.env.NODE_ENV === 'development') {
  const urlParams = new URLSearchParams(window.location.search);
  const simulateParam = urlParams.get('simulate-ios');
  const storedSimulation = localStorage.getItem('simulate-ios');
  
  const simulateVersion = simulateParam || storedSimulation;
  
  if (simulateVersion) {
    const simulationClass = simulateVersion === '15' 
      ? 'simulate-ios-15' 
      : simulateVersion === '11' 
        ? 'simulate-ios-11' 
        : 'simulate-ios';
    
    document.body.classList.add(simulationClass);
    
    if (simulateParam) {
      localStorage.setItem('simulate-ios', simulateVersion);
    }
    
    const badge = document.createElement('div');
    badge.className = 'ios-simulator-badge';
    badge.textContent = `📱 iOS ${simulateVersion === '15' ? '15 Pro' : simulateVersion === '11' ? '11' : '13 Pro'} SIMULATOR`;
    document.body.appendChild(badge);
    
    const controls = document.createElement('div');
    controls.className = 'ios-simulator-controls';
    controls.innerHTML = `
      <span style="margin-right: 8px;">🔧 Mode Simulation</span>
      <button onclick="localStorage.removeItem('simulate-ios'); window.location.href = window.location.pathname;">
        Désactiver
      </button>
    `;
    document.body.appendChild(controls);
    
    console.log('🧪 Mode simulation iOS activé');
  }
}
*/

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
